import components from './components'
import data from './data'
import props from './props'
import methods from './methods'
import computed from './computed'

export default {
  components,
  data,
  props,
  computed,
  methods
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/professional/resources/index.js